import React from 'react';
import { X, Megaphone } from 'lucide-react';
import ModalShell from '../shared/ModalShell';

const VendorBroadcastModal = ({ isOpen, onClose, notification }) => {
  const title = notification?.title || 'Broadcast';
  const message = notification?.message || '';
  const createdAt = notification?.created_at
    ? new Date(notification.created_at).toLocaleString('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : '';

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      labelledBy="vendor-broadcast-title"
      panelClassName="max-w-lg"
    >
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl max-w-lg w-full border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="p-6">
          <div className="flex items-start justify-between gap-4 mb-4">
            <div className="flex items-center gap-3">
              <div className="flex-shrink-0 w-12 h-12 bg-sky-50 dark:bg-sky-950/40 border border-sky-100 dark:border-sky-800/50 rounded-xl flex items-center justify-center">
                <Megaphone className="w-6 h-6 text-sky-600 dark:text-sky-400" />
              </div>
              <div>
                <span className="inline-block px-2.5 py-0.5 bg-sky-100 dark:bg-sky-950/50 text-sky-800 dark:text-sky-300 text-xs font-medium rounded-full mb-1">
                  Broadcast from Admin
                </span>
                <h3 id="vendor-broadcast-title" className="text-lg font-semibold text-gray-900 dark:text-gray-50">
                  {title}
                </h3>
                {createdAt && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{createdAt}</p>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 !rounded-xl transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="border-t border-gray-200 dark:border-gray-800 pt-4">
            <p className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap leading-relaxed">
              {message}
            </p>
          </div>
          <div className="mt-6 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-white bg-gray-900 dark:bg-gray-100 dark:text-gray-900 !rounded-xl hover:bg-gray-800 dark:hover:bg-gray-200 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

export default VendorBroadcastModal;
